// For full API documentation, including code examples, visit http://wix.to/94BuAAs
//import wixData from 'wix-data';
import wixLocation from 'wix-location';


$w.onReady(function () {		
//console.log('11');



	$w('#productPage').getProduct()
	 .then( (product) => {
		 //console.log('The Product Has no errors');
  } )
	 .catch( (error) => {
    //console.log(error);	
	console.log('33');
	wixLocation.to('/missingproduct');	
	})})